import { classNames } from "primereact/utils";
import { Icon, IconType } from "../../../../../common/icons/Icon";
import { WorkoutAchievementType } from "../../../../../common/enums";
import { WorkoutAchievementTypeLabels } from "../../../../../common/labels";
import { dateUtility } from "../../../../../common/infrastructure/utilities/dateUtility";
import { IWorkoutAchievement } from "../models/workoutAchievementsViewModel";
import {
  formatAchievementValue,
  formatImprovement,
  formatSetLine,
} from "../utils/achievementFormat";
import styles from "../WorkoutAchievements.module.scss";

const FALLBACK_WORKOUT_NAME = "Тренировка";

interface IAchievementCardProps {
  achievement: IWorkoutAchievement;
  onClick?: () => void;
}

/** One earned badge: trophy orb, record type, exercise, the number, and the workout it came from. */
export const AchievementCard = ({ achievement, onClick }: IAchievementCardProps) => {
  const isVolume = achievement.type === WorkoutAchievementType.MaxSetVolume;
  const workoutTitle =
    achievement.workoutName?.trim() ||
    achievement.eventName ||
    FALLBACK_WORKOUT_NAME;

  return (
    <button
      type="button"
      className={styles.badge}
      onClick={onClick}
      aria-label={`${WorkoutAchievementTypeLabels[achievement.type]} — ${achievement.exerciseName}`}
    >
      <span
        className={classNames(styles.badge_orb, {
          [styles.badge_orb_volume]: isVolume,
        })}
      >
        <Icon
          type={IconType.Trophy}
          width={26}
          height={26}
          color={isVolume ? "rgba(180, 178, 235, 0.95)" : "rgba(252, 225, 115, 0.95)"}
        />
      </span>
      <span className={styles.badge_main}>
        <span
          className={classNames(styles.badge_type, {
            [styles.badge_type_volume]: isVolume,
          })}
        >
          {WorkoutAchievementTypeLabels[achievement.type]}
        </span>
        <span className={styles.badge_exercise}>{achievement.exerciseName}</span>
        <span className={styles.badge_meta}>
          {dateUtility.formatDateTime(achievement.date)} · {workoutTitle}
        </span>
      </span>
      <span className={styles.badge_side}>
        <span className={styles.badge_value}>
          {formatAchievementValue(achievement.type, achievement.value)}
        </span>
        <span className={styles.badge_delta}>
          {formatImprovement(
            achievement.type,
            achievement.value,
            achievement.previousValue,
          )}
        </span>
        {isVolume && (
          <span className={styles.badge_set}>
            {formatSetLine(achievement.kg, achievement.reps)}
          </span>
        )}
      </span>
    </button>
  );
};
